export const initialState = {
  loadingStatus: {
    sendVerificationCodeLoading: false,
    verifyCodeLoading: false,
    holdBookingSlotLoading: false,
    releaseBookingSlotLoading: false,
    onsiteBookingSlotLoading: false,
    saveSelectedBookingSlotLoading: false,
    bookAppointmentLoading: false,
  },
  patientInfo: {
    isReturnPatient: true,
  },
  selectedBookingSlot: {},
  currentHoldingSlot: {},
  onsiteBookingData: null,
  error: '',
};
